import './App.css';
import Portfolio from "./Portfolio";
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"

function App() {
  return (
      <>
        <Portfolio/>
        <Analytics />
          <SpeedInsights/>
      </>
  );
}

export default App;
